import { logger } from '@logger'
import { notify } from '@/core/toast'
import { getSocket, isConnected } from './socketConnection'
import { CLIENT_EVENTS } from './socketEvents'

const MODULE = 'Socket Emitters'

/**
 * The one guarded emit primitive. Refuses to fire when the socket is down
 * (toast + log) so callers never have to null-check the connection.
 *
 * @returns {boolean} whether the emit was actually sent
 */
const emit = (event, payload) => {
  const socket = getSocket()
  console.log('BETDEBUG-context: raw socket emit() called', {
    event,
    payload,
    hasSocket: !!socket,
    isConnected: isConnected(),
  })
  if (!socket || !isConnected()) {
    logger.error(MODULE, `Cannot emit ${event}: socket not connected`, payload)
    notify('error', { title: 'Connection lost', sub: 'Reconnecting… please try again.' })
    return false
  }
  logger.info(MODULE, `Emit ${event}`, payload)
  socket.emit(event, payload)
  return true
}

// Thin, 1:1 wrappers around socket.emit. Validation/business rules live one
// layer up in socketService — keep these dumb and direct.
export const emitPlaceBet = (payload) => emit(CLIENT_EVENTS.PLACE_BET, payload)
export const emitCashOut = (payload) => emit(CLIENT_EVENTS.CASH_OUT, payload)
export const emitJoinRoom = (room) => emit(CLIENT_EVENTS.JOIN_ROOM, room)
export const emitLeaveRoom = (room) => emit(CLIENT_EVENTS.LEAVE_ROOM, room)
export const emitGameStats = () => emit(CLIENT_EVENTS.GAME_STATS)
export const emitLastMultipliers = () => emit(CLIENT_EVENTS.LAST_MULTIPLIERS)
